module.exports = __webpack_public_path__ + "img/zoom-in.8e414102.svg";